import { OTHER, TIME_SINKS } from '@/shared/config';

/**
 * 「가장 지겨운 반복 업무」의 저장 모양과 화면 모양을 잇는다.
 *
 * 화면은 값을 둘로 들고 있다 — 고른 보기(`topTimeSink`)와, 「기타」일 때 직접 적은
 * 문구(`topTimeSinkOther`). 서버 컬럼은 `top_time_task` **하나**다.
 *
 * 컬럼을 둘로 나누지 않은 이유: 두 값이 동시에 의미를 갖는 경우가 없다. 보기를 골랐으면
 * 자유입력은 쓰이지 않고, 「기타」면 보기 쪽에 남는 것은 「기타」라는 사실뿐이라
 * 저장한 문구가 목록에 없다는 것으로 이미 알 수 있다. 두 컬럼을 두면 둘이 어긋난 행
 * (보기를 골랐는데 자유입력도 남아 있는)이 생기고, 그때 무엇이 참인지 아무도 모른다.
 */

/** 목록에 있는 보기인가. 되읽을 때 「기타」를 가려내는 유일한 근거다. */
const isPreset = (value: string): boolean => (TIME_SINKS as readonly string[]).includes(value);

/** 화면의 두 값 → 저장할 값 하나. 「기타」면 직접 적은 문구가 그대로 저장된다. */
export function joinTimeSink(topTimeSink: string, topTimeSinkOther: string): string {
  return topTimeSink === OTHER ? topTimeSinkOther.trim() : topTimeSink;
}

/** 저장된 값 하나 → 화면의 두 값. 목록에 없으면 「기타」에 적은 문구다. */
export function splitTimeSink(stored: string | null): {
  topTimeSink: string;
  topTimeSinkOther: string;
} {
  if (stored === null || stored === '') {
    return { topTimeSink: '', topTimeSinkOther: '' };
  }

  return isPreset(stored)
    ? { topTimeSink: stored, topTimeSinkOther: '' }
    : { topTimeSink: OTHER, topTimeSinkOther: stored };
}
